import {Component, OnInit, inject} from '@angular/core';
import {
    FormGroup,
    UntypedFormBuilder,
    UntypedFormGroup,
    Validators,
    FormsModule,
    ReactiveFormsModule
} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {DataService} from "../../../services/data.service";
import {AccessService} from "../../../services/access.service";
import {ViewMode} from "../../interfaces";
import Swal from "sweetalert2";
import {FormService} from "../../../services/form.service";
import {NgIf, NgFor} from '@angular/common';

@Component({
    selector: 'app-country-detail',
    templateUrl: './country-detail.component.html',
    styleUrl: './country-detail.component.scss',
    imports: [NgIf, FormsModule, ReactiveFormsModule, NgFor]
})
export class CountryDetailComponent implements OnInit {

    accessService = inject(AccessService);
    formService = inject(FormService);
    private router = inject(Router);
    private fb = inject(UntypedFormBuilder);
    private dataService = inject(DataService);
    private route = inject(ActivatedRoute);

    readonly ViewMode = ViewMode;

    form!: UntypedFormGroup;
    id_country!: string;
    viewMode!: ViewMode;
    country: any;
    users: any[];

    ngOnInit(): void {
        this.id_country = this.route.snapshot.paramMap.get('id');
        this.viewMode = this.id_country == '0' ? ViewMode.INSERT : ViewMode.VIEW;

        this.form = this.fb.group({
            id: [null],
            short: ['', Validators.required],
            name: ['', Validators.required],
            locations: this.fb.array([]),
        });

        if (this.id_country !== '0') {
            this.getCountry();
        }

        this.dataService.request('User/listForCreation').subscribe(response => {
            this.users = response.users;
        });
    }

    getCountry(): void {
        this.dataService.request('Country/get', {
            id_country: this.id_country
        }).subscribe(response => {
            this.country = response.country;

            this.patchForm();
        });
    }

    patchForm(): void {
        this.form.patchValue({
            id: this.country.id,
            short: this.country.short,
            name: this.country.name,
        });

        this.formService.getFormArray(this.form, 'locations').clear();
        this.country.locations.forEach(location => {
            this.addFormItem(this.form, 'locations', location);
        })
    }

    addFormItem(form: FormGroup, control: string, data: any = {}): void {
        const formArray = this.formService.getFormArray(form, control);

        const group = this.fb.group({
            id: [data.id || null],
            name: [data.name || null, Validators.required],
            _deleted: [false],
        });

        formArray.push(group);
    }

    save(): void {
        this.dataService.request('Country/save', {
            country: this.form.getRawValue(),
        }).subscribe(() => {
            this.router.navigate(['/country']);
        });
    }

    update(): void {
        this.dataService.request('Country/update', {
            country: this.form.getRawValue(),
        }).subscribe(() => {
            this.setMode(ViewMode.VIEW);
            this.getCountry();
        });
    }

    cancel(): void {
        this.router.navigate(['/country']);
    }

    setMode(viewMode: ViewMode): void {
        this.viewMode = viewMode;
    }

    cancelEdit(): void {
        this.patchForm();
        this.setMode(ViewMode.VIEW);
    }

    delete(): void {
        Swal.fire({
            title: 'Sicher?',
            text: 'Das Land wird gelöscht.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('Country/delete', {
                    id_country: this.id_country
                }).subscribe(() => {
                    this.cancel();
                });
            }
        });
    }

    deleteLocation(i: number): void {
        const item = this.formService.getFormArrayItem(this.form, 'locations', i);

        if (item.value.id === null) {
            this.formService.removeFormArrayItem(this.form, 'locations', i)
        } else {
            item.patchValue({_deleted: true});
        }
    }

}
